import React from 'react'
import { Text } from 'oio-react'
import PropTypes from 'prop-types'
import RichText from 'src/sites/kits/Utils/RichText'
import { useGlobalState } from 'src/sites/state'

const ObjectDescriptionElement = ({
   description,
   placeholder,
   textSize
}) => {
   const { theme } = useGlobalState()
   const textColor = '#555' // TODO: This will be dynamic to support dark mode. PR #899
   const descriptionTextSize = textSize === 'md'
      ? theme.tmpBodyTextSize
      : theme.tmpBodyTextLgSize

   const descriptionTextLineHeight = textSize === 'md'
      ? theme.tmpBodyTextLineHeight
      : theme.tmpBodyTextLgLineHeight

   if (!description) {
      return placeholder
         ? (
            <Text
               size={descriptionTextSize}
               lineHeight={descriptionTextLineHeight}
               color={textColor}
               style={{ opacity: 0.7 }}>
               {placeholder}
            </Text>
         )
         : null
   }

   return (
      <Text
         size={descriptionTextSize}
         lineHeight={descriptionTextLineHeight}
         color={textColor}>
         <RichText float="none" html={description} />
      </Text>
   )
}

ObjectDescriptionElement.propTypes = {
   description: PropTypes.string,
   placeholder: PropTypes.string,
   textSize: PropTypes.oneOf(['md', 'lg'])
}

ObjectDescriptionElement.defaultProps = {
   description: undefined,
   placeholder: undefined,
   textSize: 'md'
}

export default ObjectDescriptionElement
